// Central content + assets for Elevate Influence landing page (FR)

export const LOGO =
  "https://customer-assets.emergentagent.com/job_agency-portal-139/artifacts/f34a29eu_Capture%20d%E2%80%99e%CC%81cran%202026-04-25%20a%CC%80%2000.35.42.png";

// URL de réservation (iClosed) — utilisée par tous les CTAs "Prendre un rendez-vous".
export const ICLOSED_URL = "https://app.iclosed.io/e/Hugo-Roussell/vsl-funnel";


export const HERO = {
  overline: "Agence de contenu pour entrepreneurs & marques",
  title: ["Devenez la référence", "de votre marché grâce à", "30 vidéos qui convertissent."],
  subtitle:
    "Nous créons tout votre contenu du mois de A à Z pour développer votre image de marque, attirer davantage de trafic qualifié et générer plus de clients.",
  cta: "Je veux devenir la référence de mon marché",
};

export const PILLARS = [
  { title: "Plus de visibilité", sub: "Un contenu pensé pour capter l'attention." },
  { title: "Plus de clients", sub: "Du trafic qualifié qui se transforme en ventes." },
  { title: "Moins de temps", sub: "4 heures de tournage par mois, on gère le reste." },
];

export const AVATARS = [
  "https://images.unsplash.com/photo-1558730234-d8b2281b0d00?crop=entropy&cs=srgb&fm=jpg&w=96&q=75",
  "https://images.unsplash.com/flagged/photo-1555604858-34f65cfdc1db?crop=entropy&cs=srgb&fm=jpg&w=96&q=75",
  "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?crop=entropy&cs=srgb&fm=jpg&w=96&q=75",
  "https://images.unsplash.com/photo-1544005313-94ddf0286df2?crop=entropy&cs=srgb&fm=jpg&w=96&q=75",
];

export const CLIENTS = [
  "Podmax", "Nach", "Alex Hitchens", "Théo Horizon", "Hakim Zwar", "Sajil", "Elevate", "Horizon",
];

// "Ils nous ont fait confiance" — real logos (transparent)
export const TRUSTED = [
  { name: "Podmax", img: "/logos/podmax.png", h: "h-12 sm:h-14" },
  { name: "Nach", img: "/logos/nach.png", h: "h-12 sm:h-14" },
  { name: "Operator Pro", img: "/logos/operator-pro.png", h: "h-12 sm:h-14" },
];

const THUMBS = [
  "https://images.unsplash.com/photo-1576176243977-7c62b6472a31?crop=entropy&cs=srgb&fm=jpg&w=600&q=80",
  "https://images.unsplash.com/photo-1692900094829-5c86578a2d48?crop=entropy&cs=srgb&fm=jpg&w=600&q=80",
  "https://images.unsplash.com/photo-1590650516494-0c8e4a4dd67e?crop=entropy&cs=srgb&fm=jpg&w=600&q=80",
  "https://images.unsplash.com/photo-1598550874175-4d0ef436c909?crop=entropy&cs=srgb&fm=jpg&w=600&q=80",
  "https://images.unsplash.com/photo-1611162617213-7d7a39e9b1d7?crop=entropy&cs=srgb&fm=jpg&w=600&q=80",
];

// Vraies vidéos verticales (9:16) pour les colonnes vidéo du Hero
export const HERO_VIDEOS = [
  "https://customer-assets.emergentagent.com/job_agency-portal-139/artifacts/ntvv4q4j_7137b385-4770-49b5-9e1c-451bb57dc0d3.mp4",
  "https://customer-assets.emergentagent.com/job_agency-portal-139/artifacts/mpvdaw2m_9849f158-1cdd-4246-9873-a6b2ea189065.mp4",
  "https://customer-assets.emergentagent.com/job_agency-portal-139/artifacts/ziwjaw21_90849dcb-1a7e-4dfb-bc55-74c7d2078791.mp4",
  "https://customer-assets.emergentagent.com/job_agency-portal-139/artifacts/wb0ntv4k_ads%20romeo%203%20corrige%CC%81.mp4",
  "https://customer-assets.emergentagent.com/job_agency-portal-139/artifacts/gtcjonr8_d51b0cb2-a426-4154-9a77-52a78f97e198.mp4",
  "https://customer-assets.emergentagent.com/job_agency-portal-139/artifacts/4y82ed3f_b727ca99-8e25-4a4d-bdda-ab87ee82b1ee.mp4",
  "https://customer-assets.emergentagent.com/job_agency-portal-139/artifacts/ctq0hxdz_thefrenchitch.mp4",
  "https://customer-assets.emergentagent.com/job_agency-portal-139/artifacts/9b3g8219__thomas_kairo_AQO_6W1B7PAKzRxfdtKgYctOTvOU4KOkcfdYzQW0ySCy9243RNZitI7rJwvjsx826fNc6m3KgwJKQyZDQkQfxFKN.mp4",
  "https://customer-assets.emergentagent.com/job_agency-portal-139/artifacts/wnk04a02_gettrade.ai_DT57bmoDeqG.mp4",
  "https://customer-assets.emergentagent.com/job_agency-portal-139/artifacts/n7p1xysp_beno.podmax_DY7qYPyO8us.mp4",
  "https://customer-assets.emergentagent.com/job_agency-portal-139/artifacts/pa80liqh_hugo.roussell.mp4",
];

// Vidéos de la "ligne des 4" — section Réalisations (lecture inline).
// Ordre demandé : les 4 premières visibles = Alex Hitchens, Podmax, Nach, Théo Horizon.
// Hakim volontairement éloigné du début ET des positions adjacentes à Alex Hitchens
// dans le carrousel circulaire (pour ne jamais apparaître "en première" au scroll).
// Aucun client consécutif dupliqué.
export const PORTFOLIO_VIDEOS = [
  {
    client: "Alex Hitchens",
    platform: "Reels",
    tag: "Organique",
    line1: "Vidéo organique",
    line2: "pour Alex Hitchens, infopreneur n°1 en France.",
    src: "https://customer-assets-7cd3h4nn.emergentagent.net/job_agency-portal-139/artifacts/4u1qwcni_d51b0cb2-a426-4154-9a77-52a78f97e198.mp4",
  },
  {
    client: "Podmax",
    platform: "Reels",
    tag: "Ads",
    line1: "Publicité payante",
    line2: "pour Podmax, studio n°1 en France.",
    src: "https://customer-assets.emergentagent.com/job_agency-portal-139/artifacts/n7p1xysp_beno.podmax_DY7qYPyO8us.mp4",
  },
  {
    client: "GetTrade",
    platform: "Reels",
    tag: "Ads",
    line1: "Publicité payante",
    line2: "pour GetTrade, plateforme de trading.",
    src: "https://customer-assets.emergentagent.com/job_agency-portal-139/artifacts/wnk04a02_gettrade.ai_DT57bmoDeqG.mp4",
  },
  {
    client: "Théo Horizon",
    platform: "TikTok",
    tag: "Organique",
    line1: "Vidéo organique",
    line2: "pour Théo Horizon, créateur de contenu.",
    src: "https://customer-assets-7cd3h4nn.emergentagent.net/job_agency-portal-139/artifacts/nysgt4tv_TikTok%20-%20Make%20Your%20Day%20%2810%29.mp4",
  },
  {
    client: "Nach",
    platform: "Reels",
    tag: "Organique",
    line1: "Vidéo organique",
    line2: "pour Sajil, dirigeant du groupe Nach.",
    src: "https://customer-assets.emergentagent.com/job_agency-portal-139/artifacts/ntvv4q4j_7137b385-4770-49b5-9e1c-451bb57dc0d3.mp4",
  },
  {
    client: "Podmax",
    platform: "Reels",
    tag: "Organique",
    line1: "Vidéo organique",
    line2: "pour Podmax, studio n°1 en France.",
    src: "https://customer-assets.emergentagent.com/job_agency-portal-139/artifacts/4y82ed3f_b727ca99-8e25-4a4d-bdda-ab87ee82b1ee.mp4",
  },
  {
    client: "Hakim",
    platform: "TikTok",
    tag: "Organique",
    line1: "Vidéo organique",
    line2: "pour Hakim, coach fitness.",
    src: "https://customer-assets.emergentagent.com/job_agency-portal-139/artifacts/i7ddhbkh_TikTok%20-%20Make%20Your%20Day-1%20%281%29.mp4",
  },
  {
    client: "Roméo",
    platform: "Reels",
    tag: "Ads",
    line1: "Publicité payante",
    line2: "faite pour Roméo Greco.",
    src: "https://customer-assets.emergentagent.com/job_agency-portal-139/artifacts/wb0ntv4k_ads%20romeo%203%20corrige%CC%81.mp4",
  },
  {
    client: "Podmax",
    platform: "Reels",
    tag: "Organique",
    line1: "Vidéo organique",
    line2: "pour Podmax, studio n°1 en France.",
    src: "https://customer-assets.emergentagent.com/job_agency-portal-139/artifacts/t89uwk9e_beno.podmax_DZQS_PtOYCJ.mp4",
  },
  {
    client: "Thomas Kairo",
    platform: "TikTok",
    tag: "Organique",
    line1: "Vidéo organique",
    line2: "pour Thomas Kairo, entrepreneur.",
    src: "https://customer-assets.emergentagent.com/job_agency-portal-139/artifacts/9b3g8219__thomas_kairo_AQO_6W1B7PAKzRxfdtKgYctOTvOU4KOkcfdYzQW0ySCy9243RNZitI7rJwvjsx826fNc6m3KgwJKQyZDQkQfxFKN.mp4",
  },
  {
    client: "Hugo Roussell",
    platform: "Reels",
    tag: "Organique",
    line1: "Vidéo organique",
    line2: "pour Hugo Roussell, expert en développement personnel.",
    src: "https://customer-assets.emergentagent.com/job_agency-portal-139/artifacts/pa80liqh_hugo.roussell.mp4",
  },
  {
    client: "Nach",
    platform: "Reels",
    tag: "Organique",
    line1: "Vidéo organique",
    line2: "pour Sajil, dirigeant du groupe Nach.",
    src: "https://customer-assets-7cd3h4nn.emergentagent.net/job_agency-portal-139/artifacts/wxc4syjl_nach.france%20%281%29.mp4",
  },
  {
    client: "Alex Hitchens",
    platform: "TikTok",
    tag: "Organique",
    line1: "Vidéo organique",
    line2: "pour Alex Hitchens, infopreneur n°1 en France.",
    src: "https://customer-assets.emergentagent.com/job_agency-portal-139/artifacts/ctq0hxdz_thefrenchitch.mp4",
  },
  {
    client: "Nach",
    platform: "Reels",
    tag: "Organique",
    line1: "Vidéo organique",
    line2: "pour Sajil, dirigeant du groupe Nach.",
    src: "https://customer-assets.emergentagent.com/job_agency-portal-139/artifacts/mpvdaw2m_9849f158-1cdd-4246-9873-a6b2ea189065.mp4",
  },
];

export const REELS = [
  { client: "Nach", platform: "Reels", url: "https://www.instagram.com/p/DZ_DCIXMIEK/" },
  { client: "Théo Horizon", platform: "TikTok", url: "https://www.tiktok.com/@theo_horizon_/video/7571142750087810326" },
  { client: "Podmax", platform: "Reels", url: "https://www.instagram.com/reel/DaD4CBoo2Bl/" },
  { client: "Hakim Zwar", platform: "TikTok", url: "https://www.tiktok.com/@hakimzwar/video/7583063188355222806" },
  { client: "Nach", platform: "Reels", url: "https://www.instagram.com/reel/DaBQjzooK_u/" },
  { client: "Théo Horizon", platform: "TikTok", url: "https://www.tiktok.com/@theo_horizon_/video/7573040663621537046" },
  { client: "Podmax", platform: "Reels", url: "https://www.instagram.com/reel/DZQS_PtOYCJ/" },
  { client: "Hakim Zwar", platform: "TikTok", url: "https://www.tiktok.com/@hakimzwar/video/7566227728412757270" },
  { client: "Alex Hitchens", platform: "Reels", url: "https://www.instagram.com/reel/DY7qYPyO8us/" },
  { client: "Nach", platform: "Reels", url: "https://www.instagram.com/p/DWyulFwiovV/" },
].map((r, i) => ({ ...r, img: THUMBS[i % THUMBS.length] }));

export const STATS = [
  { value: 300, suffix: "M+", label: "Vues générées", sub: "Cumulées sur TikTok, Reels & Shorts." },
  { value: 1.3, prefix: "", suffix: "M€+", label: "Chiffre d'affaires généré", sub: "Pour nos clients depuis 2025." },
  { value: 40, suffix: "+", label: "Entrepreneurs accompagnés", sub: "Dans des marchés totalement différents." },
];

export const WHY = [
  {
    n: "01",
    q: "Vous n'avez pas le temps de créer du contenu ?",
    body: [
      "Nous savons que votre temps est précieux. C'est pourquoi nous prenons en charge toute la partie chronophage de votre création de contenu : stratégie, scripts, tournage et montage.",
      "De votre côté, vous n'avez qu'à consacrer 4 heures par mois au tournage, soit dans l'un de nos studios partenaires Podmax, soit directement dans vos bureaux.",
      "Résultat : vous recevez chaque mois 30 vidéos prêtes à être publiées pour l'ensemble du mois, sans avoir à gérer toute l'organisation en amont.",
    ],
  },
  {
    n: "02",
    q: "Vous voulez vous démarquer de vos concurrents ?",
    body: [
      "Aujourd'hui, tout le monde crée du contenu. Mais le problème, c'est que tout le monde se ressemble.",
      "C'est pourquoi notre objectif n'est pas simplement de vous produire 30 vidéos par mois, mais de construire une image de marque forte qui vous différencie de vos concurrents et vous positionne comme la référence de votre marché.",
      "Cette approche vous permet d'obtenir des résultats dès le premier mois tout en construisant un actif durable pour votre entreprise sur le long terme.",
    ],
  },
  {
    n: "03",
    q: "Vous n'attirez pas assez de trafic qualifié ?",
    body: [
      "Le problème de 90 % des entrepreneurs sur les réseaux sociaux, ce n'est pas le manque de visibilité. Le véritable problème, c'est qu'ils attirent une audience qui n'est pas réellement intéressée par leurs produits ou leurs services.",
      "C'est pourquoi nous utilisons une méthode simple : attirer, éduquer et convertir. Nous attirons l'attention de votre client idéal, nous renforçons votre crédibilité grâce à votre expertise, puis nous transformons cette audience en clients.",
      "Car notre objectif n'est pas simplement de développer votre visibilité. Notre objectif est de vous apporter un trafic qualifié qui se transforme en clients et génère un véritable retour sur investissement pour votre entreprise.",
    ],
  },
];

export const CASES = [
  {
    client: "Podmax",
    sector: "Studio podcast n°1 en France",
    result: "+2 000 % de visibilité",
    desc: "Dès le premier mois grâce à la mise en place d'une stratégie de contenu performante et d'une image de marque premium.",
    logo: "/logos/podmax.png",
    logoClass: "h-8 sm:h-12",
    face: "/faces/podmax.webp",
    facePos: "50% 32%",
  },
  {
    client: "Alex Hitchens",
    sector: "Coach infopreneur n°1 en France",
    result: "+1M d'abonnés cumulés",
    desc: "Nous nous sommes occupés de sa stratégie de contenu court de A à Z afin de renforcer son image d'expert et son positionnement sur son marché.",
    face: "/faces/alex.jpg",
    facePos: "50% 30%",
    faceZoom: 1.5,
    faceOrigin: "50% 60%",
    holo: true,
  },
  {
    client: "Sajil",
    sector: "L'enseigne de restauration la plus virale de France",
    result: "+10M de vues en 1 mois",
    desc: "En un mois, Nach a dépassé les 10 millions de vues grâce à notre stratégie de contenu. En parallèle, nous avons construit la marque personnelle du fondateur de zéro à plus d'un million de vues, générant des centaines de prospects qualifiés dès les premiers mois.",
    logo: "/logos/nach.png",
    logoClass: "h-10 sm:h-14",
    face: "/faces/nach.jpg",
    facePos: "50% 48%",
  },
];

export const PROCESS = [
  {
    n: "01",
    title: "Diagnostic",
    text: "Nous prenons le temps de connaître nos clients ainsi que leur marché afin de leur créer une image de marque 100 % adaptée à eux et à leur cible, dans le but de performer dès le premier mois.",
  },
  {
    n: "02",
    title: "Idéation",
    text: "Notre équipe d'experts en copywriting s'occupe d'écrire tous vos concepts à votre place. Chaque contenu est conçu pour attirer, éduquer et convertir votre audience grâce à l'image de marque que nous avons créée ensemble.",
  },
  {
    n: "03",
    title: "Tournage",
    text: "Nous prenons en charge le tournage de vos vidéos à 100 %, que ce soit directement dans vos bureaux ou dans nos studios podcast partenaires. Nous vous accompagnons également avec un coaching oratoire afin de faire ressortir le meilleur de votre expertise.",
  },
  {
    n: "04",
    title: "Post-production",
    text: "Notre équipe s'occupe de toute la partie montage afin de vous faire gagner un maximum de temps. Les premières vidéos sont livrées sous 48 heures après le tournage.",
  },
  {
    n: "05",
    title: "Scaling",
    text: "Nous publions vos vidéos, analysons les résultats, ajustons la stratégie puis recommençons le processus afin de vous garantir des résultats aussi bien sur le court terme que sur le long terme.",
  },
];

export const OFFER = {
  name: "Offre signature",
  title: "Pack 30 vidéos / mois",
  desc: "Tout votre contenu du mois créé de A à Z, pensé pour vous positionner comme la référence de votre marché.",
  price: "Sur mesure",
  note: "Sans engagement · Résiliable à tout moment · Devis sous 24h",
  features: [
    "Image de marque & positionnement sur mesure",
    "Stratégie de contenu personnalisée",
    "30 concepts rédigés par nos copywriters",
    "Tournage en studio partenaire ou dans vos bureaux",
    "Coaching prise de parole face caméra",
    "Montage complet · livraison en 48 h",
    "1 vidéo prête à publier chaque jour",
    "Analyse des performances & ajustements en continu",
  ],
};

export const FAQS = [
  {
    q: "Comment êtes-vous différents des autres agences ?",
    a: [
      "La particularité de notre agence, c'est que nous avons une approche complètement sur mesure.",
      "Le but n'est pas de vous créer la même image de marque et les mêmes concepts que tous nos autres clients ou concurrents.",
      "Au contraire, nous cherchons à créer votre élément de différenciation afin de vous positionner comme la référence de votre marché.",
      "Là où la plupart des agences se contentent de vendre des vidéos, des vues peu qualifiées et des résultats à court terme, notre objectif est de construire un véritable actif pour votre entreprise.",
      "Grâce à la création d'une image de marque forte qui vous différencie de vos concurrents, vous obtenez des résultats concrets : davantage de visibilité, plus de trafic qualifié, et une augmentation durable de votre chiffre d'affaires.",
      "Et parce que nous avons conscience de la valeur de votre temps, nous nous occupons de l'ensemble du processus afin que vous puissiez vous concentrer sur le développement de votre entreprise.",
    ],
  },
  {
    q: "Comment pouvez-vous être sûr que les vidéos fonctionnent pour moi ?",
    a: [
      "Tout simplement parce que nous obtenons des résultats dans des marchés complètement différents.",
      "Depuis 2025, nous avons généré plus de 300 millions de vues et contribué à plus de 1,3 million d'euros de chiffre d'affaires pour nos clients.",
      "Nous avons accompagné des groupes de restauration comme Nach, des studios de podcast comme Podmax, des e-commerçants comme Théo Horizon qui a généré plus de 70 000 € en un mois, ou encore des coachs sportifs comme Hakim Zwar qui a dépassé les 180 000 € de chiffre d'affaires.",
    ],
  },
  {
    q: "Comment se passent les tournages ?",
    a: [
      "Nous pouvons tourner vos vidéos dans l'un de nos studios podcast partenaires, entièrement pris en charge par nos soins, ou nous déplacer directement dans vos bureaux afin de filmer votre contenu.",
      "Si vous n'êtes pas en France, ce n'est pas un problème. Nous vous accompagnons à distance grâce à nos scripts, notre coaching face caméra et notre méthode de prise de parole, afin que vous puissiez créer du contenu de qualité où que vous soyez.",
    ],
  },
  {
    q: "Quel est le délai de livraison des vidéos ?",
    a: [
      "La première semaine est consacrée à la construction de votre image de marque, de votre positionnement et de votre stratégie de contenu.",
      "La deuxième semaine est dédiée à la création de vos 30 concepts ainsi qu'au tournage de vos vidéos.",
      "Ensuite les premières vidéos sont livrées sous 48 heures après le tournage afin que vous puissiez commencer à publier immédiatement, à raison d'une vidéo par jour.",
    ],
  },
  {
    q: "Quel engagement implique notre offre ?",
    a: [
      "Vous n'avez aucun engagement de durée. Vous signez pour un mois et pouvez résilier à tout moment.",
      "Notre objectif n'est pas de vous enfermer dans un contrat, mais de vous garder grâce aux résultats obtenus dès le premier mois.",
    ],
  },
];
